import React from 'react';
import PropTypes from 'prop-types';
import Header from 'js/components/Header';
import Footer from 'cccisd-footer';
import style from './style.css';

export default class FixedLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        showPrimaryNav: PropTypes.bool,
        showSecondaryNav: PropTypes.bool,
        showFooter: PropTypes.bool,
    };

    static defaultProps = {
        className: 'container',
        showPrimaryNav: true,
        showSecondaryNav: true,
        showFooter: true,
    };

    render() {
        return (
            <div className={style.wrapper}>
                <Header />
                <div className={style.body}>
                    <div className={this.props.className}>{this.props.children}</div>
                </div>

                {this.props.showFooter && (
                    <div className={style.footer}>
                        <Footer className={this.props.className} />
                    </div>
                )}
            </div>
        );
    }
}
